import { QueryList, AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { MapLocation } from './location-map.model';
import { RadiusOption, radiusOptions } from '../../dashboard/servicesComponets/disaster/radiusOptions';
import { GoogleMap, MapMarker, MapInfoWindow } from '@angular/google-maps';

declare let google: any;

@Component({
  selector: 'location-map',
  providers: [],
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.css'],
})
export class LocationMapComponent implements OnChanges, AfterViewInit {
  private countryInternal: string;

  private geocoder: any;
  center: google.maps.LatLngLiteral = { lat: -34.397, lng: 150.644 };
  @Input()
  set country(country: string) {
    if (country) {
      this.countryInternal = country;
      this.loadCountry();
      if (this.editable) {
        this.clearLocations();
      }
    }
  }
  private get locations(): MapLocation[] {
    return Array.isArray(this.source) ? this.source : [this.source];
  }

  @Input() showAll = false;
  openInfo(markerElem: MapMarker, infoWindow: MapInfoWindow, marker) {
    if (this.showInfoWindow) {
      infoWindow.open(markerElem);
    } else {
      marker.visible = !marker.visible
      infoWindow.close();
    }
  }

  get country() {
    return this.countryInternal;
  }

  @Input() source: MapLocation | MapLocation[] | null;

  @Input() multi = false;

  @Input() editable = true;

  @Input() showInfoWindow = true;

  @Output() locationAdded: EventEmitter<MapLocation> = new EventEmitter<MapLocation>();

  @Output() radiusChanged: EventEmitter<MapLocation> = new EventEmitter<MapLocation>();

  @Output() locationRemoved: EventEmitter<MapLocation> = new EventEmitter<MapLocation>();

  @ViewChild(GoogleMap) map: GoogleMap;
  @ViewChildren(MapMarker) markers: QueryList<MapMarker>;
  @ViewChildren("infoWindow") infoWindows: QueryList<MapInfoWindow>;

  // Default coordinates, in case country is not selected.
  centerLatitude = -34.397;
  centerLongitude = 150.644;

  radii: RadiusOption[] = radiusOptions;
  selectedMarker: MapLocation | null = null;

  constructor() {
    this.source = this.source ? (this.source instanceof Array ? this.source : [this.source]) : [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.source) {
      this.source = changes.source.currentValue;
    }
  }

  isAddingMarker = false;

  ngAfterViewInit() {
    this.map.googleMap?.setCenter(this.center);
    this.infoWindows.changes.subscribe(() => {
      if (this.isAddingMarker) {
        setTimeout(() => {
          const lastWindow = this.infoWindows.last;
          const lastMarker = this.markers.last;
          if (lastWindow && lastMarker) {
            // now the window knows which marker to anchor to
            lastWindow.open(lastMarker);
          }
          this.isAddingMarker = false;
        }, 200);
      }
    });
  }


  loadCountry() {
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder();
    }
    this.getCountryDetails(this.country);
  }

  getCountryDetails(location: string) {
    this.geocoder.geocode({ address: location }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        this.center = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        this.map.googleMap?.setCenter(this.center);
      } else {
        alert('Could not find location: ' + location);
      }
    });
  }

  mapClicked(event: google.maps.MapMouseEvent): void {
    if (!this.editable || !event.latLng) return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    this.center = { lat, lng };

    const location: MapLocation = {
      geoLatitude: lat,
      geoLongitude: lng,
      radius: this.radii[0].value,
    };

    if (this.source === null) this.source = [];
    if (!(this.source instanceof Array)) this.source = [this.source];

    (this.source as MapLocation[]).push(location);
    this.locationAdded.emit(location);
    this.isAddingMarker = true;
  }

  onMarkerClicked(marker) {
    marker.visible = !marker.visible;
  }

  getDisplayValue(rad: number): string {
    const displayValue = this.radii.find((radius) => radius.value === rad);
    return displayValue.display;
  }

  onRadiusChanged(radius: number, geoLatitude: number, geoLongitude: number): void {
    const location = { geoLatitude, geoLongitude, radius };
    if (this.multi) {
      const sourceLocation = (this.source as MapLocation[]).find(
        (loc) => loc.geoLatitude === geoLatitude && loc.geoLongitude === geoLongitude
      );
      if (sourceLocation) sourceLocation.radius = radius;
    } else {
      (this.source as MapLocation).radius = radius;
    }
    this.radiusChanged.emit(location);
  }

  onMarkerDelete(location: MapLocation): void {
    if (this.multi) {
      const index = (this.source as MapLocation[]).indexOf(location);
      (this.source as MapLocation[]).splice(index, 1);
    } else {
      this.source = null;
    }
    this.locationRemoved.emit(location);
  }

  clearLocations() {
    if (this.source) {
      if (this.multi) {
        this.source = [];
      } else {
        this.locationRemoved.emit(<MapLocation>this.source);
      }
    }
  }

  resize() {
    if (this.map && this.map.googleMap) {
      google.maps.event.trigger(this.map.googleMap, 'resize');
    }
  }
}
